import { useQuery } from '@tanstack/react-query';

import cycleEvaluationGroupService from './cycleEvaluationGroupService';
import { partitionDormantCycleEvaluations } from './dormantCycleEvaluations';

import type { CycleEvaluationGroup } from '@/types/cycle-evaluation/CycleEvaluationGroup';

import { CycleEvaluationGroupQueryKey } from '@/constants/QueryKeys';

const useGetCycleEvaluationGroup = (id?: string) => {
    return useQuery<CycleEvaluationGroup>({
        queryKey: [CycleEvaluationGroupQueryKey.CYCLE_EVALUATION_GROUP, id],
        queryFn: () => cycleEvaluationGroupService.getCycleEvaluationGroup(id!),
        select: partitionDormantCycleEvaluations,
        enabled: !!id,
    });
};

export { useGetCycleEvaluationGroup };
